import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Grid } from "@mui/material";

import { useExperienceAnalysis } from "../../../../api/ai/experience-analysis";
import { TestPilotButton } from "../../../../components/Buttons/TestPilotButton";
import {
  dispatchExperienceAnalysis,
  experienceAnalysis,
} from "../../../../store/slices/ai";
import { mpClickAiExperienceRegenerateButton } from "../../../../utils/mixpanel";

export const RegenerateButton = () => {
  const analysis = useSelector(experienceAnalysis);
  const dispatch = useDispatch();
  const experienceAnalysisMutation = useExperienceAnalysis();

  if (analysis.messages.length) {
    return (
      <Grid item sx={{ minWidth: "135px", marginTop: "12px" }}>
        <TestPilotButton
          loading={!analysis.isMessageComplete}
          onClick={() => {
            dispatch(
              dispatchExperienceAnalysis({
                type: "back",
              })
            );
            dispatchExperienceAnalysis({
              type: "setDataProgress",
              value: 1,
            });
            if (analysis.experience) {
              experienceAnalysisMutation.mutate({
                body: {
                  assistantId: analysis.assistantId,
                  experienceId: analysis.experience.id!,
                  queryTemplate: analysis.queryTemplate || "summary",
                  threadId: "new",
                  query: analysis.query,
                },
                pathParams: undefined,
                queryParams: undefined,
              });
            }
            mpClickAiExperienceRegenerateButton();
          }}
          text={
            analysis.messages.some((m) => m.role === "user")
              ? "Start Over"
              : "Regenerate"
          }
          dark={true}
          hasAccess={true}
        />
      </Grid>
    );
  }

  return null;
};
